<template>
  <div id="app"><br>
    <fancy-grid-vue 
      :title="title"
      :width="width"
      :height="height"
      :data="configData"
      :resizable="true"
      :defaults="defaults"
      :sel-model="'rows'"
      :config="gridConfig" 
      :trackOver="true"
      :columns="columns">
    </fancy-grid-vue>
  </div>
</template>

<script>
import FancyGridVue from 'fancy-grid-vue';
import ReportServices from '@/services/ReportServices'

export default {
  name: 'app',
  data: function(){
    return {
      title: "Sangam Paarivallal Members",
      width: 'fit',
      height: 'fit',
      resizable: true,
      defaults: this.getDefaults(),
      columns: this.getColumns(),
      configData: [],
      gridConfig: {
        theme: 'default',
        resizable: true,
        renderTo: "container",
        trackOver: true,
        selModel: "rows",
        clicksToEdit: 1,
        columnLines: false,
        columnClickData: true,
        exporter: true,
        paging: {
          pageSize: 25,
          pageSizeData: [25,50, 75, 100]
        },
        tbar: [
            {
              type: 'search',
              width: '400',
              searchText: 'Search'
            },
            {
              text: 'Export to Excel',
              handler: function() {
                this.exportToExcel();
              }
            }
        ]
      },
    }
  },
  methods: {
    async refresh() {
      this.configData = (await ReportServices.getPaariVallalMembers()).data
    },
    getColumns: function(){
      return [
        {
          index: 'firstname',
          title: 'First Name',
          flex : '1'
        },{
          index: 'lastname',
          title: 'Last Name',
        },
        {
          index: 'membershipcategory',
          title: 'Membership',
        },
        {
          index: 'year',
          title: 'Year',
        }
      ]
    },
    getDefaults: function(){
      return {
        type: 'string',
        width: 200,
        sortable: true,
        editable: true,
        resizable: true,
        cellAlign: 'left',
        align: 'left'
      }
    }
  },
  components: {
    FancyGridVue
  },
  async mounted() {
    this.refresh()
  }
}
</script>